// imported images
import MC from '../images/MC Headshot.jpg';
import CH from '../../src/images/CH Headshot.JPG';
import TW from '../images/TW Headshot2.jpg';

export const managementData = [
	{
		name: 'Mike Callaghan',
		image: MC,
		title: 'President',
		bio:
			'Michael retired from the Chicago Police Department after 22 years of service. He has been working in the trade show industry since 1987. Michael has experience working on-site, managing the many large events as well as security consulting in Orlando, Las Vegas, New Orleans, Chicago and San Diego, to name a few. Michael’s expertise includes but is not limited to, Executive protection, Crisis Management, Counterterrorism, Emergency Management, Security Operations, Homeland Security, Asset Protection and Access Control.',
		id: 1,
	},
	{
		name: 'Christine Hayward',
		image: CH,
		title: 'Vice President',
		bio:
			'Christine graduated from University of Central Florida with a double major in Marketing and Finance. She has been in the hospitality and event industry since childhood. Christine has many years of experience in preparing and facilitating security plans with both show management and the venue. She can assist in coordinating and contracting Off Duty Law Enforcement, K9s, and Event Medical services for events and incorporating them into one contract. Christine has knowledge with events in different cities across the country.',
		id: 2,
	},
	{
		name: 'Tristan Wong',
		image: TW,
		title: 'Director of Operations',
		bio:
			'With a strong technical background supported by production and management experience, Tristan manages daily on-site security operations. Tristan has experience working on several events with many diverse roles and responsibilities for over seven years and has experience in many different types of events from concerts to conventions. In addition, Tristan oversees all CCTV equipment installation and dismantle, logistics, and monitoring in several cities.  ',
		id: 3,
	},
];

export const servicesData = [
	{
		title: 'Security',
		icon: 'guards',
		info:
			'OPS offers a wide range of security services, specializing in trade shows, conventions and special events. We have armed, unarmed and executive protection security officers available. ',
		id: 1,
	},
	{
		title: 'Event Staffing',
		icon: 'staff',
		info:
			'Customer service comes first! We have talented and experienced staff waiting to work your next event. We offer bag fulfillment, room monitors, registration assistance, ticket takers, directional staff and secretaries to name a few.',
		id: 2,
	},
	{
		title: 'CCTV',
		icon: 'cctv',
		info:
			'OPS is experienced in temporary CCTV installations for trade show and conventions. Our CCTV units come equipped with one terabit DVRs that have 24hr recording capabilities and 4 cameras with professional stands. In addition, a central viewing station can be installed. Depending on your space and/or event CCTV installations can assist with asset protection, crowd control and overall flow of your event.',
		id: 3,
	},
	{
		title: 'Event Security Consulting',
		icon: 'consultant',
		info:
			'The OPS Management Team has experience with trade shows and conventions throughout the US. We can assist with all your security needs, from start to finish. Let us take care of security, when planning your next convention.',
		id: 4,
	},
	{
		title: 'Contracted Services',
		icon: 'contract',
		info:
			'Let OPS be your one stop shop! We’ve maintained relationships with companies that offer other convention services, which allow our clients to sign one contract and send one deposit. Let us coordinate your Off-Duty Law Enforcement, K9s and Medical services, as you already have enough to plan.',
		id: 5,
	},
];
